// Events Category Filter
document.addEventListener('DOMContentLoaded', function() {
  const filterButtons = document.querySelectorAll('.events-filter-btn');
  const categorySelect = document.getElementById('events-category-select');
  const categorySections = document.querySelectorAll('.events-category-section');

  if (categorySections.length === 0) {
    return;
  }

  // Function to switch category
  function switchCategory(targetCategory) {
    // Show/hide category sections
    categorySections.forEach(function(section) {
      const sectionCategory = section.getAttribute('data-category');

      if (sectionCategory === targetCategory) {
        section.classList.remove('is-hidden');

        // Reinitialize Splide for this section based on conditions
        const slider = section.querySelector('.events-slider');
        if (slider && typeof window.initializeEventSlider === 'function') {
          window.initializeEventSlider(slider);
        }

        // Trigger animations on visible cards
        const cards = section.querySelectorAll('.splide__slide');
        cards.forEach(function(card) {
          card.style.animation = 'none';
          // Force reflow
          void card.offsetWidth;
          card.style.animation = '';
        });
      } else {
        section.classList.add('is-hidden');
      }
    });

    // Scroll to filters section smoothly
    const filtersSection = document.querySelector('.events-filters');
    if (filtersSection) {
      const offset = 100;
      const elementPosition = filtersSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  // Desktop: Button clicks
  if (filterButtons.length > 0) {
    filterButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const targetCategory = this.getAttribute('data-category');

        // Update active button
        filterButtons.forEach(function(btn) {
          btn.classList.remove('is-active');
        });
        this.classList.add('is-active');

        // Switch category
        switchCategory(targetCategory);
      });
    });
  }

  // Mobile: Select change
  if (categorySelect) {
    categorySelect.addEventListener('change', function() {
      const targetCategory = this.value;
      switchCategory(targetCategory);
    });
  }

  // URL parameter: ?category=slug
  var urlParams = new URLSearchParams(window.location.search);
  var categoryParam = urlParams.get('category');

  if (categoryParam) {
    var matchingBtn = document.querySelector('.events-filter-btn[data-category="' + categoryParam + '"]');

    if (matchingBtn) {
      filterButtons.forEach(function(btn) {
        btn.classList.remove('is-active');
      });
      matchingBtn.classList.add('is-active');

      if (categorySelect) {
        categorySelect.value = categoryParam;
      }

      switchCategory(categoryParam);
    }
  }
});
